var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"box"},[_c('p',{staticClass:"title"},[_vm._v("UUPS!")]),_c('p',{staticClass:"sub-title"},[_vm._v("Nie znaleziono takiej strony.")]),_c('b-button',{attrs:{"to":"/","id":"go-back"}},[_vm._v("Powrót do strony głównej")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }